import React from 'react';
import classNames from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import HighlightedCampaign from './HighlightedCampaign';

import './style.scss';

const HighlightedCampaigns = ({ entity }: { entity: any }) => {
  const paragraph = entity.toJS();
  const highlightedCampaignClass = classNames('col-12 mt-3 mt-lg-4', {
    single: paragraph.field_campaigns.length === 1,
    'col-lg-6 double':
      paragraph.field_campaigns.length === 2 ||
      paragraph.field_campaigns.length === 4,
    'col-lg-4 triple': paragraph.field_campaigns.length === 3,
  });

  return (
    <Container className="HighlightedCampaigns">
      <div className="row">
        {paragraph.field_campaigns.map((campaign: any) => (
          <HighlightedCampaign
            entity={campaign.entity}
            className={highlightedCampaignClass}
          />
        ))}
      </div>
    </Container>
  );
};

export default HighlightedCampaigns;
